import moment from 'moment';
import NoRecordIcon from '../../../components/Icons/NoRecordIcon';
import { IUser } from '@/interfaces/user.model';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import PaginationComponent from '@/components/common/PaginationComponent';
import { IUserAttendance } from '@/interfaces/attendance.model';
interface IAttendanceTableProps {
  attendanceList: IUserAttendance[];
  dateFilter: string[];
  userDetails: IUser | null;
  count: number;
  pageSize: number;
  currentPage: number;
  isLoading?: boolean;
  totalPages: number;
  pageChangeHandler?: (PageNo: number) => void;
  handleChangePageSize?: (value: number) => void;
  handleChangeAttendance: (
    newStatus: number,
    userId: string,
    userName: string,
    date: string,
  ) => void;
}
const AttendanceTable = ({
  attendanceList = [],
  dateFilter,
  count,
  isLoading,
  pageSize,
  totalPages,
  currentPage,
  pageChangeHandler,
  handleChangePageSize,
  handleChangeAttendance,
}: IAttendanceTableProps) => {
  const userDetails = useSelector((state: RootState) => state?.user?.user);
  const pageSizes = [10, 20, 30, 40, 50, 100];
  const generateMonthDays = () => {
    const start = moment(dateFilter[0]);
    const days = [];
    const totalDays = start.daysInMonth();
    for (let i = 1; i <= totalDays; i++) {
      days.push(i);
    }
    return days;
  };

  return (
    <>
      <div className="table-responsive">
        <table className="table table-bordered table-sm align-middle text-center">
          <thead className="table-light text-center align-middle">
            {attendanceList?.length > 0 && (
              <tr>
                <th>Sr. No.</th>
                <th>Employee</th>
                <th>Emp. Code</th>
                {generateMonthDays()?.map((day) => (
                  <th key={day} className="p-2">
                    <span className="badge bg-light border border-1 text-black rounded-pill fs-5 fw-semibold px-3 py-2">
                      {String(day).padStart(2, '0')}
                    </span>
                  </th>
                ))}
              </tr>
            )}
          </thead>

          <tbody>
            {attendanceList?.length > 0 ? (
              attendanceList.map((user, index) => (
                <tr key={user.id}>
                  <td>{index + 1}</td>
                  <td className="text-start">
                    <div className="d-flex align-items-center gap-2">
                      {user?.profilePhoto && (
                        <img
                          loading="lazy"
                          src={user.profilePhoto}
                          alt=""
                          width={32}
                          height={32}
                          className="rounded-circle object-fit-cover"
                        />
                      )}
                      <span>{user.name}</span>
                    </div>
                  </td>
                  <td>{user.employeeCode}</td>
                  {generateMonthDays()?.map((day) => {
                    const att = user?.attendances?.find(
                      (a) => moment(a.checkInTime).date() === day,
                    );
                    const statusValue = att?.status ?? 'pending';
                    const getClassName = () => {
                      switch (statusValue) {
                        case 1:
                          return 'text-success';
                        case 0:
                          return 'text-danger';
                        case 3:
                          return 'text-info';
                        case 4:
                          return 'text-warning';
                        case 5:
                          return 'text-warning';
                        case 6:
                          return 'text-warning';
                        case 7:
                          return 'text-danger';
                        case 8:
                          return 'text-danger';
                        case 9:
                          return 'text-primary';
                        case 10:
                          return 'text-danger';
                        default:
                          return 'text-warning';
                      }
                    };
                    const currentMonthDate = moment(dateFilter[0]).date(day);
                    const isFutureDate = currentMonthDate.isAfter(
                      moment(),
                      'day',
                    );
                    console.log(att?.isHoliday);
                    const isDisabled =
                      isFutureDate ||
                      att?.isLockedAttendance ||
                      userDetails?.department?.name !== 'Management';

                    return (
                      <td key={day}>
                        <select
                          className={`form-select fw-normal p-2 py-1 rounded-4 ${getClassName()}`}
                          style={{
                            borderColor:
                              statusValue === 1
                                ? '#28a745'
                                : statusValue === 0 ||
                                    statusValue === 7 ||
                                    statusValue === 8 ||
                                    statusValue === 10
                                  ? '#dc3545'
                                  : statusValue === 3
                                    ? '#0dcaf0'
                                    : statusValue === 9
                                      ? '#0d6efd'
                                      : '#ffc107',
                            color:
                              statusValue === 1
                                ? '#28a745'
                                : statusValue === 0 ||
                                    statusValue === 7 ||
                                    statusValue === 8 ||
                                    statusValue === 10
                                  ? '#dc3545'
                                  : statusValue === 3
                                    ? '#0dcaf0'
                                    : statusValue === 9
                                      ? '#0d6efd'
                                      : '#ffc107',
                            fontWeight: 500,
                            width: '80px',
                          }}
                          value={statusValue}
                          onChange={(e) =>
                            handleChangeAttendance(
                              Number(e.target.value),
                              user?.id,
                              user?.name,
                              moment(dateFilter[0])
                                .date(day)
                                .format('YYYY-MM-DD'),
                            )
                          }
                          disabled={isDisabled}
                        >
                          {statusValue === 'pending' && (
                            <option className="d-none" value="pending" disabled>
                              --
                            </option>
                          )}
                          {att?.isHoliday && (
                            <option
                              style={{ color: 'red', display: 'none' }}
                              value={7}
                            >
                              H
                            </option>
                          )}
                          <option style={{ color: 'green' }} value={1}>
                            P
                          </option>
                          <option style={{ color: 'red' }} value={0}>
                            A
                          </option>
                          <option style={{ color: 'red' }} value={3}>
                            L
                          </option>
                          <option
                            value={4}
                            style={{ color: 'orange', display: 'none' }}
                          >
                            PL
                          </option>
                          <option
                            value={5}
                            style={{ color: 'orange', display: 'none' }}
                          >
                            PR
                          </option>
                          <option
                            value={6}
                            style={{ color: 'orange', display: 'none' }}
                          >
                            PWFH
                          </option>
                          <option
                            style={{ color: 'red', display: 'none' }}
                            value={7}
                          >
                            WO
                          </option>
                          <option
                            style={{ color: 'red', display: 'none' }}
                            value={8}
                          >
                            HDL
                          </option>
                          <option
                            style={{ color: 'blue', display: 'none' }}
                            value={9}
                          >
                            WFH
                          </option>
                          <option
                            style={{ color: 'red', display: 'none' }}
                            value={10}
                          >
                            CAN AR
                          </option>
                        </select>
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td className="text-center border-0 py-5">
                  <div className="d-flex flex-column justify-colmn-center align-items-center no-data-error">
                    <NoRecordIcon />
                    {'No record found'}
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {attendanceList?.length > 0 && (
        <div className="d-flex justify-content-between align-items-center pt-3">
          <div className="d-flex align-items-center gap-2">
            {count > 0 && !isLoading && (
              <div className="dropdown short">
                <button
                  className="btn dropdown-toggle border"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {pageSize}
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M6.40039 8.19922L10.0004 11.7992L13.6004 8.19922"
                        stroke="#36394A"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </span>
                </button>
                <ul className="dropdown-menu ">
                  {pageSizes.map((value) => (
                    <li key={value}>
                      <button
                        className={`dropdown-item ${
                          pageSize === value && 'active'
                        }`}
                        type="button"
                        onClick={() =>
                          handleChangePageSize && handleChangePageSize(value)
                        }
                      >
                        {value}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <div>
              {count > 0 && !isLoading && (
                <p
                  className="mb-0 text-muted fw-medium text-uppercase text-nowrap"
                  style={{ fontSize: '12px' }}
                >
                  {`Showing ${currentPage * pageSize - (pageSize - 1)} to ${
                    currentPage * pageSize < count
                      ? currentPage * pageSize
                      : count
                  } of ${count} entries`}
                </p>
              )}
            </div>
          </div>
          <PaginationComponent
            currentPage={currentPage}
            pageChangeHandler={pageChangeHandler}
            totalPages={totalPages}
            pageSize={pageSize}
          />
        </div>
      )}
    </>
  );
};

export default AttendanceTable;
